import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { WyzaiLogo } from './icons/Logo';

const TopBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  if (isHomePage) return null; // 首页不显示顶部栏

  return (
    <div className="top-bar">
      <div className="top-bar__content">
        <button className="top-bar__logo" onClick={() => navigate('/')}>
          <WyzaiLogo size={28} />
          <span className="top-bar__logo-text">wyzai</span>
        </button>
        
        <div className="top-bar__breadcrumb">
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">
            {location.pathname === '/query' && '令牌查询'}
            {location.pathname === '/transfer' && '余额转移'}
            {location.pathname === '/claude-docs' && 'Claude Code'}
            {location.pathname === '/pricing' && '模型价格'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TopBar;

